import { Tooltip } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';
import { COLORS } from '@guuru/theme-common';
import HorizontalLayout from './HorizontalLayout';
import VerticalLayout from './VerticalLayout';

interface HighlightCardProps {
  url: string;
  name?: string;
  subTitle?: string;
  avatar?: string;
  footer?: React.ReactNode;
  extraTitle?: React.ReactNode;
  isLoading?: boolean;
  tooltip?: string;
  actions?: (string | React.ReactNode)[];
}

interface VerticalHighlightCardProps extends HighlightCardProps {
  title: string;
  description?: string;
  descriptionRows?: number;
  layout?: 'vertical';
}

interface HorizontalHighlightCardProps extends HighlightCardProps {
  title: React.ReactNode;
  description?: React.ReactNode;
  descriptionRows?: number;
  layout?: 'horizontal';
}

const HighlightCard = function ({
  url,
  title,
  description = undefined,
  isLoading = false,
  avatar = undefined,
  name = undefined,
  subTitle = undefined,
  footer = null,
  extraTitle = null,
  actions = [],
  tooltip = '',
  layout = 'vertical',
  descriptionRows = 6,
}: VerticalHighlightCardProps | HorizontalHighlightCardProps) {
  return (
    <Link to={url}>
      <Tooltip
        title={tooltip}
        color={COLORS.primaryColor}
        placement="top"
        arrow={false}
        align={{ offset: [0, 20] }}
        styles={{ root: { cursor: 'pointer' } }}
        autoAdjustOverflow={false}
        zIndex={1}
      >
        <span>
          {layout === 'vertical' ? (
            <VerticalLayout
              loading={isLoading || (!isLoading && !title)}
              title={title as string}
              avatar={avatar}
              subTitle={subTitle}
              description={description as string}
              extraTitle={extraTitle}
              footer={footer}
              actions={actions}
              name={name}
              descriptionRows={descriptionRows}
            />
          ) : (
            <HorizontalLayout
              loading={isLoading || (!isLoading && !title)}
              description={description}
              title={title}
              avatar={avatar}
              name={name}
            />
          )}
        </span>
      </Tooltip>
    </Link>
  );
};

export default HighlightCard;
